import { axios } from '../../services/axios';

export default async function createSRTTrunk(payload) {
    const result = await axios.post('/trunk/create', payload, {
        headers: { 'Content-Type': 'application/json' },
    });
    return result;
}
